// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
/* eslint-disable import/no-anonymous-default-export */
import memberCollectionActionTypes from './member-collection.types';
import { docodeHexResponse } from '../../../_common/common.utils';
const INITIAL_STATE = {
	getSearchMemberLoanListStatus: null,
	getSearchMemberLoanListResponse: null,
	getSearchMemberLoanListArr: [],
	getMemberLoanInfoResponse: null,
	getMemberLoanInfoArr: [],
	updatedMemberCollectionResponse: null,
	fetchMemberCollectionResponse: null,
	fetchMemberCollectionArr: [],
	revertMemberCollectionResponse: null,
	fetchMemberWalletArr: [],
	fetchMemberWalletResponse: null,
	addMemberWalletResponse: null,
	fetchMemberQrArr: [],
	fetchMemberQrResponse: null,
	fetchMemberRepaymentArr: [],
	fetchMemberRepaymentResponse: null,
	revertMemberWalletResponse: null,
	getMemberLoanCardPdfResponse: null,
	getMemberLoanCardPdfArr: [],
	getMemberRepaymentPdfResponse: null,
	getMemberRepaymentPdfArr: [],
	getMemberLoanCardReportResponse: null,
	getMemberLoanCardReportArr: [],
	memberLoanCollectionApprovalResponse: null,
	memberLoanCollectionApprovalArr: [],
	getSearchMemberSavingDetailsResponse: null,
	getSearchMemberSavingDetailsArr: [],
	getParticularAccountInfoResponse: null,
	getParticularAccountInfoArr: [],
	addSavingMemberSavingDetailsResponse: null,
	updateLoanPaidEntryReponse: null,
	updateArrearLoanPaidEntryReponse: null,
	getThriftCollectionDetailsReponse: null,
	revertThriftCollectionReponse: null,
	getThriftCollectionDetailsArr: [],
};

export default (state = INITIAL_STATE, action: { type: any; payload: any }) => {
	switch (action.type) {
		/************************ GET SEARCH MEMBER LOAN LIST START ****************** */
		case memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_SUCCESS:
			return {
				...state,
				getSearchMemberLoanListResponse: action.payload,
				getSearchMemberLoanListArr: docodeHexResponse(
					action.payload,
					'searchMemberLoanListKey',
				),
			};

		case memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_FAILURE:
			return {
				...state,
				getSearchMemberLoanListResponse: action.payload,
			};

		case memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getSearchMemberLoanListResponse: null,
			};
		/************************ GET SEARCH MEMBER LOAN LIST END ****************** */

		/************************ GET SEARCH MEMBER LOAN INFO START ****************** */
		case memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_SUCCESS:
			return {
				...state,
				getMemberLoanInfoResponse: action.payload,
				getMemberLoanInfoArr: docodeHexResponse(
					action.payload,
					'LoanInfoMemberLoanListKey',
				),
			};

		case memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_FAILURE:
			return { ...state, getMemberLoanInfoResponse: action.payload };

		case memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_RESPONSE_CHANGED:
			return { ...state, getMemberLoanInfoResponse: null };
		/************************ GET SEARCH MEMBER LOAN INFO END ****************** */

		/************************ UPDATE MEMBER COLLECTION START ****************** */
		case memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_SUCCESS:
			return { ...state, updatedMemberCollectionResponse: action.payload };

		case memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_FAILURE:
			return { ...state, updatedMemberCollectionResponse: action.payload };

		case memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_RESPONSE_CHANGED:
			return { ...state, updatedMemberCollectionResponse: null };
		/************************  UPDATE MEMBER COLLECTION END ****************** */

		/************************  UPDATE MEMBER DEATH START ****************** */
		case memberCollectionActionTypes.UPDATE_MEMBER_DEATH_SUCCESS:
			return { ...state, updatedMemberDeathResponse: action.payload };

		case memberCollectionActionTypes.UPDATE_MEMBER_DEATH_FAILURE:
			return { ...state, updatedMemberDeathResponse: action.payload };

		case memberCollectionActionTypes.UPDATE_MEMBER_DEATH_RESPONSE_CHANGED:
			return { ...state, updatedMemberDeathResponse: null };
		/************************  UPDATE MEMBER DEATH END ****************** */

		/************************  UPDATE INTEREST WAIVER START ****************** */
		case memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_SUCCESS:
			return { ...state, updatedInterestWaiverResponse: action.payload };

		case memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_FAILURE:
			return { ...state, updatedInterestWaiverResponse: action.payload };

		case memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_RESPONSE_CHANGED:
			return { ...state, updatedInterestWaiverResponse: null };
		/************************  UPDATE INTEREST WAIVER END ****************** */

		/************************  GET MEMBER COLLECTION START ****************** */
		case memberCollectionActionTypes.GET_MEMBER_COLLECTION_SUCCESS:
			return {
				...state,
				fetchMemberCollectionResponse: action.payload,
				fetchMemberCollectionArr: docodeHexResponse(
					action.payload,
					'FetchMemberCollectionDataKey',
				),
			};

		case memberCollectionActionTypes.GET_MEMBER_COLLECTION_FAILURE:
			return { ...state, fetchMemberCollectionResponse: action.payload };

		case memberCollectionActionTypes.GET_MEMBER_COLLECTION_RESPONSE_CHANGED:
			return { ...state, fetchMemberCollectionResponse: null };
		/************************  GET MEMBER COLLECTION END ****************** */

		/************************  GET MEMBER WALLET START ****************** */
		case memberCollectionActionTypes.GET_MEMBER_WALLET_SUCCESS:
			return {
				...state,
				fetchMemberWalletResponse: action.payload,
				fetchMemberWalletArr: docodeHexResponse(action.payload, 'FetchMemberWalletDataKey'),
			};

		case memberCollectionActionTypes.GET_MEMBER_WALLET_FAILURE:
			return { ...state, fetchMemberWalletResponse: action.payload };

		case memberCollectionActionTypes.GET_MEMBER_WALLET_RESPONSE_CHANGED:
			return { ...state, fetchMemberWalletResponse: null };
		/************************  GET MEMBER WALLET END ****************** */

		/************************  ADD MEMBER WALLET START ****************** */
		case memberCollectionActionTypes.ADD_MEMBER_WALLET_SUCCESS:
			return {
				...state,
				addMemberWalletResponse: action.payload,
			};

		case memberCollectionActionTypes.ADD_MEMBER_WALLET_FAILURE:
			return { ...state, addMemberWalletResponse: action.payload };

		case memberCollectionActionTypes.ADD_MEMBER_WALLET_RESPONSE_CHANGED:
			return { ...state, addMemberWalletResponse: null };
		/************************  ADD MEMBER WALLET END ****************** */

		/************************  GET MEMBER QR START ****************** */
		case memberCollectionActionTypes.GET_MEMBER_QR_SUCCESS:
			return {
				...state,
				fetchMemberQrResponse: action.payload,
				fetchMemberQrArr: docodeHexResponse(action.payload, 'FetchMemberQrDataKey'),
			};

		case memberCollectionActionTypes.GET_MEMBER_QR_FAILURE:
			return { ...state, fetchMemberQrResponse: action.payload };

		case memberCollectionActionTypes.GET_MEMBER_QR_RESPONSE_CHANGED:
			return { ...state, fetchMemberQrResponse: null };
		/************************  GET MEMBER QR END ****************** */

		/************************  GET MEMBER REPAYMENT START ****************** */
		case memberCollectionActionTypes.GET_MEMBER_REPAYMENT_SUCCESS:
			return {
				...state,
				fetchMemberRepaymentResponse: action.payload,
				fetchMemberRepaymentArr: docodeHexResponse(
					action.payload,
					'FetchMemberRepaymentDataKey',
				),
			};

		case memberCollectionActionTypes.GET_MEMBER_REPAYMENT_FAILURE:
			return { ...state, fetchMemberRepaymentResponse: action.payload };

		case memberCollectionActionTypes.GET_MEMBER_REPAYMENT_RESPONSE_CHANGED:
			return { ...state, fetchMemberRepaymentResponse: null };
		/************************  GET MEMBER REPAYMENT END ****************** */

		/************************  DELETE MEMBER WALLET START ****************** */
		case memberCollectionActionTypes.DELETE_MEMBER_WALLET_SUCCESS:
			return { ...state, revertMemberWalletResponse: action.payload };

		case memberCollectionActionTypes.DELETE_MEMBER_WALLET_FAILURE:
			return { ...state, revertMemberWalletResponse: action.payload };

		case memberCollectionActionTypes.DELETE_MEMBER_WALLET_RESPONSE_CHANGED:
			return { ...state, revertMemberWalletResponse: null };
		/************************  DELETE MEMBER WALLET END ****************** */

		/************************  REVERT MEMBER COLLECTION START ****************** */
		case memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_SUCCESS:
			return { ...state, revertMemberCollectionResponse: action.payload };

		case memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_FAILURE:
			return { ...state, revertMemberCollectionResponse: action.payload };

		case memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_RESPONSE_CHANGED:
			return { ...state, revertMemberCollectionResponse: null };
		/************************  REVERT MEMBER COLLECTION END ****************** */

		/***************** MEMBER LOAN CARD PDF START ***********************/
		case memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_FAILURE:
			return {
				...state,
				getMemberLoanCardPdfResponse: 'Failure',
			};

		case memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_RESPONSE_CHANGED:
			return { ...state, getMemberLoanCardPdfResponse: null };

		case memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_SUCCESS:
			return {
				...state,
				getMemberLoanCardPdfResponse: 'Success',
				getMemberLoanCardPdfArr: action.payload,
			};

		/*****************  MEMBER LOAN CARD PDF END ***********************/

		/***************** MEMBER REPAYMENT PDF START ***********************/
		case memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_FAILURE:
			return {
				...state,
				getMemberRepaymentPdfResponse: 'Failure',
			};

		case memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_RESPONSE_CHANGED:
			return { ...state, getMemberRepaymentPdfResponse: null };

		case memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_SUCCESS:
			return {
				...state,
				getMemberRepaymentPdfResponse: 'Success',
				getMemberRepaymentPdfArr: action.payload,
			};

		/*****************  MEMBER REPAYMENT PDF END ***********************/

		/***************** MEMBER LOAN CARD REPORT START ***********************/
		case memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_FAILURE:
			return {
				...state,
				getMemberLoanCardReportResponse: 'Failure',
			};

		case memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_RESPONSE_CHANGED:
			return { ...state, getMemberLoanCardReportResponse: null };

		case memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_SUCCESS:
			return {
				...state,
				getMemberLoanCardReportResponse: 'Success',
				getMemberLoanCardReportArr: action.payload,
			};

		/*****************  MEMBER LOAN CARD REPORT END ***********************/

		/***************** MEMBER LOAN COLLECTION APPROVAL START ***********************/
		case memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_FAILURE:
			return {
				...state,
				memberLoanCollectionApprovalResponse: action.payload,
			};

		case memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED:
			return { ...state, memberLoanCollectionApprovalResponse: null };

		case memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_SUCCESS:
			return {
				...state,
				memberLoanCollectionApprovalResponse: action.payload,
				memberLoanCollectionApprovalArr: action.payload,
			};

		/*****************  MEMBER LOAN COLLECTION APPROVAL END ***********************/

		/***************** MEMBER LOAN COLLECTION APPROVAL START ***********************/
		case memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_FAILURE:
			return {
				...state,
				updateLoanPaidEntryReponse: action.payload,
			};

		case memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_RESPONSE_CHANGED:
			return { ...state, updateLoanPaidEntryReponse: null };

		case memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_SUCCESS:
			return {
				...state,
				updateLoanPaidEntryReponse: action.payload,
			};

		/*****************  MEMBER LOAN COLLECTION APPROVAL END ***********************/

		/***************** MEMBER LOAN COLLECTION APPROVAL START ***********************/
		case memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_FAILURE:
			return {
				...state,
				updateArrearLoanPaidEntryReponse: action.payload,
			};

		case memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_RESPONSE_CHANGED:
			return { ...state, updateArrearLoanPaidEntryReponse: null };

		case memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_SUCCESS:
			return {
				...state,
				updateArrearLoanPaidEntryReponse: action.payload,
			};

		/*****************  MEMBER LOAN COLLECTION APPROVAL END ***********************/

		/************************ GET THRIFT COLLECTION DETAILS START ****************** */
		case memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_FAILURE:
			return {
				...state,
				getThriftCollectionDetailsReponse: action.payload,
			};

		case memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getThriftCollectionDetailsReponse: null };

		case memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_SUCCESS:
			return {
				...state,
				getThriftCollectionDetailsReponse: action.payload,
				getThriftCollectionDetailsArr: action.payload,
			};
		/************************ GET THRIFT COLLECTION DETAILS END ****************** */

		/************************ REVERT THRIFT COLLECTION START ****************** */
		case memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_FAILURE:
			return {
				...state,
				revertThriftCollectionReponse: action.payload,
			};

		case memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_RESPONSE_CHANGED:
			return { ...state, revertThriftCollectionReponse: null };

		case memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_SUCCESS:
			return {
				...state,
				revertThriftCollectionReponse: action.payload,
			};
		/************************ REVERT THRIFT COLLECTION END ****************** */

		default:
			return state;
	}
};
